import * as React from 'react';
import { createService } from '../../createService';
import { PremiumIcon } from '../../icons';

export const PremiumBetService = createService({
  title: 'Ваша ставка',
  subTitle: 'Премиум',
  description: ['Заметнее в поиске', 'Больше просмотров', '1 фото и ваш заголовок'],
  dataName: 'PremiumBetService',
  bgColor: 'white',
  icon: <PremiumIcon />,
});
